import { GraphQLFormattedError } from 'graphql';
import _some from 'lodash/some';
import _isEmpty from 'lodash/isEmpty';
import { GraphqlErrorCode } from '@lib/enums/graphqlErrorCodes';
import { emitVersionMismatch } from '@lib/utils/versionMismatchEvent';

export function hasVersionMismatchError(
  graphQLErrors: readonly GraphQLFormattedError[] | undefined,
): boolean {
  return _some(
    graphQLErrors,
    ({ extensions }) =>
      extensions?.code === GraphqlErrorCode.UndefinedField ||
      extensions?.code === GraphqlErrorCode.SelectionMismatch,
  );
}

export function handleGraphQLErrors(
  graphQLErrors: readonly GraphQLFormattedError[] | undefined,
  captureException: (error: Error, response?: unknown) => void,
): void {
  if (!graphQLErrors) return;

  const isVersionMismatch = hasVersionMismatchError(graphQLErrors);
  if (isVersionMismatch) {
    emitVersionMismatch();
  }

  const isProblemExist = _some(
    graphQLErrors,
    ({ extensions }) => !_isEmpty(extensions?.problems),
  );

  if (isProblemExist || isVersionMismatch) {
    graphQLErrors.forEach((error) => {
      captureException(
        new Error(`[GraphQL error]: Message: ${error.message}`),
        error,
      );
    });
  }
}
